import {
  ActionType,
  BaseActionWidget,
  ServerActionWidget,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import BatchUpdatePromotionType from './BatchUpdatePromotionType.vue';
import { queryPromotionType } from '../../field/form/MindMap/services';

const MODEL = 'deli.aries.seller.DeliAriesTodChangePptModel';

@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.Client,
    name: '$$internal_BatchUpdate',
    model: MODEL,
    widget: 'ClientAction'
  })
)
export class BatchUpdatePromotionTypeAction extends ServerActionWidget {
  initialize(props: any) {
    super.initialize(props);
    this.setComponent(BatchUpdatePromotionType);
    return this;
  }

  @Widget.Reactive()
  protected get selectRecords() {
    return (this.parentActiveRecords ?? []) as any[];
  }

  @Widget.Reactive()
  protected get allRecords() {
    return (this.dataSource ?? []) as any[];
  }

  @Widget.Method()
  public async loadPromotionTypeOptions() {
    const res = await queryPromotionType(this.model);
    return (res?.promotionTypeEnumList ?? []).map((item: any) => ({
      label: item.displayName,
      value: item.value
    }));
  }

  // 未勾选则修改全部，勾选则仅修改选中行；直接就地写入表格行数据。
  @Widget.Method()
  public applyPromotionType(value: string) {
    const selected = (this.parentActiveRecords ?? []) as any[];
    const changeAll = selected.length === 0;
    const targets = changeAll ? ((this.dataSource ?? []) as any[]) : selected;
    targets.forEach((row) => {
      row.newPromotionPlanType = value;
    });
    return targets.length;
  }
}
